window.addEventListener("DOMContentLoaded",()=>{
    const review_us_tab = document.querySelector('.review-us-tab');
    if(review_us_tab){
        review_us_tab.addEventListener('click',()=>{
            review_us_tab.classList.toggle('open')
        })
        window.addEventListener('click',(e)=>{
            if(!e.target.closest('.review-us-tab')){
                review_us_tab.classList.remove('open')
            }
        })
    }
})